function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import mapiHandlers from './mapiHandlers';
const LOADED_SEARCH_EVENT = 'frontend-shell:loaded-search';
const CHANGE_DISPLAYED_ITINERARIES = 'frontend-shell:change-displayed-itineraries';
const NO_SEARCH_RESULTS = 'frontend-shell:no-search-results';
const RESULTS_PAGE_LOADING = 'frontend-shell:results-page-loading';
const CHEAPEST_ITINERARY_PRICE_KEY = 'cheapestItineraryPrice';
export const createSearchHandlers = of1Props => {
  const {
    trigger
  } = of1Props;
  const handleSearchLoaded = () => {
    trigger(LOADED_SEARCH_EVENT, false, true);
  };
  const handleDisplayedItinerariesChange = (actualPage = 1, cheapestItineraryPrice, itinerariesCounter) => {
    window.sessionStorage.setItem(CHEAPEST_ITINERARY_PRICE_KEY, cheapestItineraryPrice);
    trigger(CHANGE_DISPLAYED_ITINERARIES, actualPage, cheapestItineraryPrice, itinerariesCounter);
  };
  const handleNoSearchResults = () => {
    trigger(NO_SEARCH_RESULTS);
  };
  const handleLoadingResultsPage = () => {
    trigger(RESULTS_PAGE_LOADING);
  };
  return _objectSpread({
    handleSearchLoaded,
    handleDisplayedItinerariesChange,
    handleNoSearchResults,
    handleLoadingResultsPage
  }, mapiHandlers(of1Props));
};